import type { SessionRecord } from "./types";

const KEY = "shuttlecock:sessions:v1";

export function loadSessions(): SessionRecord[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    if (!Array.isArray(data)) return [];
    return data as SessionRecord[];
  } catch {
    return [];
  }
}

export function saveSessions(sessions: SessionRecord[]) {
  localStorage.setItem(KEY, JSON.stringify(sessions));
}

// Ensures this file is treated as a module
export {};